import { API_BASE_URL } from "@kupikupi/brand";
import { useMutation } from "@tanstack/react-query";
import type { CaptchaTokenProvider } from "../captcha-retry";
import { registerUser } from "../endpoints/user";
import type { RegisterRequest } from "../types/user";

interface CaptchaProviderOpts {
  captchaTokenProvider?: CaptchaTokenProvider | undefined;
}

/** Wraps `POST /user/register`. Returns LoginVo (token + userInfo subset) on success. */
export function useRegister(opts: CaptchaProviderOpts = {}) {
  return useMutation({
    mutationFn: async (body: RegisterRequest) => {
      const captchaToken = await opts.captchaTokenProvider?.();
      return registerUser(
        { baseUrl: API_BASE_URL },
        captchaToken === undefined ? body : { ...body, captchaToken },
      );
    },
  });
}
